import consts from "shared/consts";
import { openSignupPage } from "utils/signup-utils";
import { getPathPrefix } from "../../utils/getPathPrefix";
import { signUpToContinueModalAtom } from "state-atoms/modal-atoms";
import { useAtom } from "jotai";
import UpgradeModalGeneric from "./upgrade-modal";
import style from "./upgrade-modal.module.css";

export default function SignUpToContinue() {
  const [showSignUpToContinueModal, setShowSignUpToContinueModal] = useAtom(signUpToContinueModalAtom);

  const hideModal = () => {
    setShowSignUpToContinueModal(false);
  };

  if (!showSignUpToContinueModal) {
    return null;
  }

  return (
    <UpgradeModalGeneric
      title="You are editing as a guest collaborator"
      mainTitle="Sign up for a free account"
      content="Or log in to your existing account to unlock more features."
      bulletpoints={[
        "Blazing fast multiplayer",
        "Task management",
        "Commenting",
        "A world of templates",
        "Quality file export",
      ]}
      upgradeButtonText="Create free account"
      trialDays={consts.TRIAL_DAYS_DEFAULT_PERIOD}
      imageClassName={style.signUpAnonymousImage}
      image={getPathPrefix("/images/upgrade-modal-images/sign-up-anonymous.png")}
      onDismiss={hideModal}
      onUpgrade={() => {
        openSignupPage("sign_up_as_anonymous_modal");
        hideModal();
      }}
      trackingEvent="sign_up_as_anonymous_modal"
      trackEventName="sign_up_as_anonymous_modal"
      insideModal={false}
    />
  );
}
